var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { registerRoute, setCatchHandler, } from "workbox-routing";
import { NetworkFirst, StaleWhileRevalidate, NetworkOnly, CacheFirst, CacheOnly, } from "workbox-strategies";
import * as navigationPreload from "workbox-navigation-preload";
import { matchPrecache, precacheAndRoute } from "workbox-precaching";
import { BroadcastUpdatePlugin } from "workbox-broadcast-update";
import { RangeRequestsPlugin } from "workbox-range-requests";
/*
https://gitlab.com/remarkablenet/wordpress-projects/remarkablenet/-/blob/master/theme/sw.js
https://gitlab.com/remarkablenet/moss-bros/moss/-/blob/develop/Retail/Cortana.Responsive/Content/js/service-worker.js
*/
// Global broadcast message when cache updated
var broadcastUpdatePlugin = new BroadcastUpdatePlugin();
export var defaults = {
    cacheKey: "v1",
    precache: [],
    fallbackURLs: {
        HTML: "/static/pwa/offline",
        IMAGE: "/content/misc/offline-image.jpg",
        PLP: "/static/pwa/offlinePLP",
        JSON: "/static/pwa/offlinejson",
    },
    rules: {
        NetworkOnly: [
            /\/api\/?(\?.*)?/,
            "/static/pwa/clientconfig",
            /\/checkout\/?(\?.*)?/,
            "/id.aspx",
            "/debug.aspx",
            "/service/healthcheck",
            "/caching/*",
            "/content/misc/site.webmanifest",
        ],
        NetworkFirst: [
            /\/basket\/?(\?.*)?/,
            "/cms",
            /\/account\/?(\?.*)?/,
            "/saved-items",
        ],
        CacheFirst: [],
        CacheOnly: [],
        StaleWhileRevalidate: [],
    },
};
export var GenerateRCMServiceWorker = function (options) {
    if (options === void 0) { options = defaults; }
    var __options = __assign(__assign({}, defaults), __assign(__assign({}, options), { rules: __assign(__assign({}, defaults.rules), options.rules) }));
    // @ts-ignore
    var PWACACHEKEY = __options.cacheKey;
    var precache = __spreadArray(__spreadArray([], __read(Object.values(__options.fallbackURLs).map(function (path) { return ({
        url: path,
        revision: PWACACHEKEY,
    }); })), false), __read(__options.precache.map(function (path) { return ({
        url: path,
        revision: PWACACHEKEY,
    }); })), false);
    // precaching
    navigationPreload.enable();
    precacheAndRoute(precache);
    registerRoute(function (_a) {
        var url = _a.url;
        return url.pathname.endsWith(".mp4");
    }, new CacheFirst({
        plugins: [new RangeRequestsPlugin()]
    }));
    // NetworkOnly
    __options.rules.NetworkOnly.forEach(function (path) {
        return registerRoute(path, new NetworkOnly());
    });
    __options.rules.NetworkFirst.forEach(function (path) {
        return registerRoute(path, new NetworkFirst());
    });
    __options.rules.CacheFirst.forEach(function (path) {
        return registerRoute(path, new CacheFirst());
    });
    __options.rules.CacheOnly.forEach(function (path) {
        return registerRoute(path, new CacheOnly());
    });
    __options.rules.StaleWhileRevalidate.forEach(function (path) {
        return registerRoute(path, new StaleWhileRevalidate({
            plugins: [broadcastUpdatePlugin]
        }));
    });
    setCatchHandler(function (_a) {
        var event = _a.event, request = _a.request;
        return __awaiter(void 0, void 0, void 0, function () {
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(request.method === "GET" &&
                            (request.headers.get("accept") || "").includes("application/json"))) return [3 /*break*/, 2];
                        return [4 /*yield*/, matchPrecache(__options.fallbackURLs.JSON)];
                    case 1: return [2 /*return*/, _c.sent()];
                    case 2:
                        if (!(request.method === "GET" && request.url.includes("page="))) return [3 /*break*/, 4];
                        return [4 /*yield*/, matchPrecache(__options.fallbackURLs.PLP)];
                    case 3: return [2 /*return*/, _c.sent()];
                    case 4:
                        if (!(request.method === "POST")) return [3 /*break*/, 6];
                        return [4 /*yield*/, matchPrecache(__options.fallbackURLs.HTML)];
                    case 5: return [2 /*return*/, _c.sent()];
                    case 6:
                        _b = request.destination;
                        switch (_b) {
                            case "document": return [3 /*break*/, 7];
                            case "image": return [3 /*break*/, 9];
                        }
                        return [3 /*break*/, 11];
                    case 7: return [4 /*yield*/, matchPrecache(__options.fallbackURLs.HTML)];
                    case 8: return [2 /*return*/, _c.sent()];
                    case 9: return [4 /*yield*/, matchPrecache(__options.fallbackURLs.IMAGE)];
                    case 10: return [2 /*return*/, _c.sent()];
                    case 11: return [2 /*return*/, Response.error()];
                }
            });
        });
    });
    self.addEventListener("install", function (event) {
        self.skipWaiting();
    });
};
